export default "__VITE_PUBLIC_ASSET__6906ef5e__"